var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/var/www/html/demo/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/templates/analyzer-summary.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "Optimized ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "optimized_images"), env.opts.autoescape);
output += " images, <strong>";
output += runtime.suppressValue(env.getFilter("filesize").call(context, runtime.contextOrFrameLookup(context, frame, "orig_size")), env.opts.autoescape);
output += "</strong> reduced to <strong>";
output += runtime.suppressValue(env.getFilter("filesize").call(context, runtime.contextOrFrameLookup(context, frame, "optimized_size")), env.opts.autoescape);
output += "</strong>, saved <strong>";
output += runtime.suppressValue(env.getFilter("filesize").call(context, runtime.contextOrFrameLookup(context, frame, "saved_size")), env.opts.autoescape);
output += "</strong> (<strong>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "saved_percent"), env.opts.autoescape);
output += "%</strong>)";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/templates/analyzer-summary.njk"] , dependencies)